module.exports = __webpack_public_path__ + "static/media/fourth-banner-mobile.ceef0015.png";